const initialState = {};

export default function purchasesReducer(state = initialState, action) {
  switch (action.type) {
    case "PRODUCT_PURCHASES_FETCHED":
    case "USER_PURCHASES_FETCHED":
      return {
        ...state,
        ...action.payload.entities.purchases
      };
    default:
      return state;
  }
}
